import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Container, Block } from "@bw/bits"
import { breakpoints } from "../../../theme"

const PageHeaderWrapper = styled.div`
  position: relative;

  + section {
    margin-top: 40px;
  }
`

const Image = styled.div`
  display: none;

  @media (min-width: ${breakpoints.medium}px) {
    display: block;
    position: relative;
    z-index: -1;
    padding: 0;
    width: 100%;
    top: 0;
    height: 275px;
  }

  &:after {
    content: "";
    display: block;
    position: absolute;
    inset: 0;
    background-color: var(--page-color-rgba);
    z-index: 1;
  }

  .gatsby-image-wrapper {
    height: 100%;
  }

  img {
    object-position: ${props => props.focus};
  }
`
const Absolute = styled.div`
  position: relative;
  left: -15px;
  width: calc(100vw - 20px);
  @media (min-width: ${breakpoints.medium}px) {
    margin-top: -153px;
    left: -95px;
  }

  @media (min-width: 1115px) {
    left: -78px;
  }
`

const PageHeader = ({
  color,
  suptitle,
  title,
  pictogram,
  subtitle,
  image,
  focus,
}) => {
  return (
    <PageHeaderWrapper>
      <Container size="large">
        <Image focus={focus}>{image}</Image>
        <Container size="medium">
          <Absolute>
            <Block
              titleSize="h1small"
              titleLevel={1}
              type="title"
              color={color}
              blockSuptitle={suptitle}
              blockTitle={title}
              icon={pictogram}
            >
              {subtitle}
            </Block>
          </Absolute>
        </Container>
      </Container>
    </PageHeaderWrapper>
  )
}

PageHeader.propTypes = {
  pictogram: PropTypes.element,
  suptitle: PropTypes.string,
  title: PropTypes.string,
  color: PropTypes.oneOf(["green", "orange", "blue", "purple", "yellow"]),
  subtitle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
  ]).isRequired,
  image: PropTypes.element,
  focus: PropTypes.string,
}

PageHeader.defaultProps = {
  focus: "center",
}

export { PageHeader }
